module.exports = __webpack_public_path__ + "static/media/snapback-bolts.e40d17ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/features/snapback-bolts.png
// module id = 1201
// module chunks = 0